module.exports = __webpack_public_path__ + "static/media/2.4.6db96e89.png";